import axios from 'axios'
const { ADMIN_API_URL } = process.env

const adminRequest = axios.create({
  baseURL: ADMIN_API_URL || 'https://example.com/', // API server url
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export default adminRequest
